import script from "./OfferShow.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferShow.vue?vue&type=script&setup=true&lang=js"

import "./OfferShow.vue?vue&type=style&index=0&id=f4be77f6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4be77f6"]])

export default __exports__